import Headroom from 'headroom.js'
import MicroModal from 'micromodal'
import Rellax from 'rellax'
import scrollMonitor from 'scrollmonitor'
// import 'slick-carousel'

//Logo Fade-in
const logoFadein = () => {
  setTimeout(() => {
    $('.logos, .main-title').addClass('appear')
  }, 500)
}

/**
 * Fade in text for Gutenberg blocks.
 */
const fadeInText = () => {
  const fadeInEvent = ($el) => {
    let el = $el[0], 
      watcher = scrollMonitor.create(el, -500)

    watcher.one('enterViewport', ()=> {
      $el.find('.faded').addClass('in-view')
    })
  }

  $('.block\\(hero\\), .block\\(imageAndText\\), .block\\(threeImageAndText\\), .block\\(updates\\)').each(function () {
    fadeInEvent($(this))
  })
}

//Modal Functionality
const modal = () => {
  MicroModal.init({
    awaitCloseAnimation: true,
  })
}

//Headroom and slider nav functionality
const initHeader = () => {
  let headroom = new Headroom(document.querySelector('header'), {
      tolerance: 10,
    })
  headroom.init()
  $(document).on('click', '[data-toggle-nav]', () => {
    $('.menu-btn').toggleClass('active')
    $('.mobile').toggleClass('nav-active')
    $('body').toggleClass('no-scroll')
  })
}

/** 
 * Add parallax functionality to decorations
 * @param {string} selector
 */
const initRellax = (selector) => {
  let decoration = document.querySelector(selector)
  if (decoration) {
    new Rellax(selector)
  }
}

/**
 * Slider
 */
// const slider = () => {
//   $('.slides').slick({
//     arrows: false,
//     dots: false,
//     infinite: true,
//     swipeToSlide: true,
//     slidesToShow: 3,
//     responsive: [
//       {
//         breakpoint: 1220,
//         settings: {
//           slidesToShow: 2,
//         },
//       },
//       {
//         breakpoint: 800,
//         settings: {
//           slidesToShow: 1,
//           centerMode: true,
//           variableWidth: true,
//           initialSlide: 0,
//         },
//       },
//     ],
//   })
// }

/** 
 * Check All checkboxes
 */
const checkAll = () => {
  $('#filter-issues').click(() => {
    if ($('#filter-issues').is(':checked')) {
      $('input[type="checkbox"].issues-group').prop('checked', true);
      $('input[type="checkbox"].issues-group').each(function () {
        $('.' + this.value).show();
      });
    } else {
      $('input[type="checkbox"].issues-group').prop('checked', false);
      $('input[type="checkbox"].issues-group').each(function () {
        $('.' + this.value).hide();
      });
    }
  })

  $('input[type="checkbox"].issues-group').change(() => {
    var a = $('input[type="checkbox"].issues-group');
    if (a.length == a.filter(':checked').length) {
      $('#filter-issues').prop('checked', true);
    } else {
      $('#filter-issues').prop('checked', false);
    }

    $('input[type="checkbox"].issues-group').each(function () {
      $('.' + this.value).hide();
    });

    $('.issue-container input[type=checkbox]:checked').each(function () {
      $('.' + this.value).show();
    });
  })

  $('#filter-pillars').click(() => {
    if ($('#filter-pillars').is(':checked')) {
      $('input[type="checkbox"].pillars-group').prop('checked', true);
      $('input[type="checkbox"].pillars-group').each(function () {
        $('.' + this.value).show();
      });
    } else {
      $('input[type="checkbox"].pillars-group').prop('checked', false);
      $('input[type="checkbox"].pillars-group').each(function () {
        $('.' + this.value).hide();
      });
    }
  })

  $('input[type="checkbox"].pillars-group').change(() => {
    var b = $('input[type="checkbox"].pillars-group');
    if (b.length == b.filter(':checked').length) {
      $('#filter-pillars').prop('checked', true);
    } else {
      $('#filter-pillars').prop('checked', false);
    }

    $('input[type="checkbox"].pillars-group').each(function () {
      $('.' + this.value).hide();
    });

    $('.pillar-container input[type=checkbox]:checked').each(function () {
      $('.' + this.value).show();
    });
  })
}

//Smooth scroll
$(function() {
  $('a[href*="#"]:not([href="#"])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top - 100,
        }, 1000);
        return false;
      }
    }
  });
});

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    fadeInText()
    initHeader()
    initRellax('.parallax')
    logoFadein()
    modal()
    // slider()
    checkAll()
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js